<template>
  <PolicyLayout :page="page" />
</template>

<script>
import PolicyLayout from "./PolicyLayout.vue";
import { loadSiteContent } from "@/services/siteContent";

export default {
  components: { PolicyLayout },
  data() {
    return {
      page: {
        eyebrow: "用户协议",
        title: "用户协议",
        lead: "使用 pizzaking 前请阅读本协议。协议说明账号规则、平台使用、支付、饰品和服务限制等内容。",
        sourceLabel: "PizzaKing 版本 · 2026",
        sections: [
          {
            title: "用户行为",
            text:
              "你需要对账号下的内容、操作和活动负责，不得滥用服务、绕过平台规则、干扰系统、冒充他人或将本站用于违法行为。",
          },
          {
            title: "账号与安全",
            text:
              "pizzaking 使用手机号和密码账号体系。你需要妥善保管登录凭证，并对账号下执行的所有操作负责。",
          },
          {
            title: "饰品与钱包",
            text:
              "数字饰品和账号余额用于平台内体验，不属于现金、现金等价物，也不保证具备外部市场价值。",
          },
          {
            title: "服务可用性",
            text:
              "平台可能因维护、风控、安全或运营原因进行更新、暂停或调整。界面显示错误不代表用户有权获得特定结果。",
          },
          {
            title: "第三方服务",
            text:
              "部分支付、发货、机器人或平台接口可能依赖第三方服务，其可用性和处理规则可能影响账号操作。",
          },
          {
            title: "年龄与资格",
            text:
              "用户必须满足所在地适用的法定年龄和资格要求。如账号违反相关规则，平台可限制其访问。",
          },
        ],
      },
    };
  },
  mounted() {
    loadSiteContent(this.$axios).then((content) => {
      this.page = content.agreement;
    });
  },
};
</script>
